import React from "react";
import { Customers, StackedLogos } from "components/logos";
import { useCdpIndustry } from "contexts/cdp-industry-context";
import { type Customer, type Page } from "lib/sanity";
import { type SpaceProps } from "@chakra-ui/react";

type CustomerLogosProps = {
  industrySolutionPage?: Page;
  stackedLogos: Customer[][];
};

const spaceProps: SpaceProps = { my: 0, pt: "bigger" };

export function CdpIndustriesCustomerLogos({ industrySolutionPage, stackedLogos }: CustomerLogosProps) {
  const { industry } = useCdpIndustry();

  if (industrySolutionPage?.customers) {
    const title = `Trusted by leading ${industry.pluralNoun}`;
    return industrySolutionPage.customers.length === 8 ? (
      <StackedLogos
        customerRows={[industrySolutionPage.customers]}
        mobileCustomers={industrySolutionPage.customers}
        title={title}
        {...spaceProps}
      />
    ) : (
      <Customers title={title} customers={industrySolutionPage.customers} {...spaceProps} />
    );
  }

  return <StackedLogos customerRows={stackedLogos} {...spaceProps} />;
}
